export default function () {

}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/form/resources/mounted.js